import React from "react";
import style from "../../scss/export.module.scss";

type TPipeSeparator = {
    height?: string;
    margin?: string;
    backgroundColor?: string;
};

export const PipeSeparator = ({
    height = "20px",
    margin = "3px",
    backgroundColor = style.greyColor,
}: TPipeSeparator) => {
    const styles: React.CSSProperties = {
        width: "2px",
        height,
        marginRight: margin,
        marginLeft: margin,
        backgroundColor,
    };

    return <div style={styles}></div>;
};
